import {
  mixinThemeDetection
} from "./chunk.5OVLHNGV.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  SlAlert
} from "./chunk.BBHA2P2S.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  alternate_alert_styles_default
} from "./chunk.QXHTX5EI.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/alternate-alert/alternate-alert.ts
var FadvAlternateAlert = class extends mixinThemeDetection(SlAlert) {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "prefix", "suffix");
    this.pill = false;
  }
  getThemeDefaults() {
    return {
      "c-elements": {
        pill: true,
        duration: 3e3
      },
      "e-elements": {
        pill: false,
        duration: 3e3
      }
    };
  }
  render() {
    return $`<div part="base" class=${o({
      "alt-alert": true,
      "alt-alert--open": this.open,
      "alt-alert--pill": this.pill,
      "alt-alert--primary": this.variant === "primary",
      "alt-alert--secondary": this.variant === "secondary",
      "alt-alert--tertiary": this.variant === "tertiary",
      "alt-alert--neutral": this.variant === "neutral",
      "alt-alert--success": this.variant === "success",
      "alt-alert--warning": this.variant === "warning",
      "alt-alert--danger": this.variant === "danger",
      "alt-alert--has-prefix": this.hasSlot.test("prefix"),
      "alt-alert--has-suffix": this.hasSlot.test("suffix")
    })} role="alert" aria-live="assertive" aria-atomic="true" aria-hidden=${this.open ? "false" : "true"} @mousemove=${this.handleMouseMove} ><span part="prefix" class="alt-alert__prefix"><slot name="prefix"></slot></span><fadv-typography type="label-medium" weight="500" part="message" class="alt-alert__message"><slot></slot></fadv-typography><span part="suffix" class="alt-alert__suffix"><slot name="suffix"></slot></span></div>`;
  }
};
FadvAlternateAlert.styles = alternate_alert_styles_default;
__decorateClass([
  e({ type: Boolean })
], FadvAlternateAlert.prototype, "pill", 2);
FadvAlternateAlert = __decorateClass([
  n("fadv-alternate-alert")
], FadvAlternateAlert);

export {
  FadvAlternateAlert
};
